import { ApiService } from "./apiService";
const apiService = new ApiService();

export default class BasicViewService {
  saveInsightsViewConfig(name, data, viewType) {
    const res = apiService.requestInsightsViewConfigPOST(
      `/insights/views/create/${viewType}?name=${name}`,
      data
    );
    return res;
  }

  updateInsightsViewConfig(id, data) {
    const res = apiService
      .requestInsightsViewConfigUpdatePOST(`/insights/views/update/${id}`, data)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  updateFavoriteInsightViewConfig(id) {
    const res = apiService
      .requestInsightsViewConfigPUT(`/insights/views/favorite/${id}`, null)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  updateInsightsViewConfig2(id, data) {
    const res = apiService
      .requestInsightsViewConfigPOST(`/insights/views/update/${id}`, data)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  deleteInsightsViewConfig(id) {
    const res = apiService
      .requestInsightsViewConfigDELETE(`/insights/views/${id}`)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  fetchInsightsViewsDefinitions(viewType, dateRange = null) {
    const res = apiService
      .requestInsightsViewDefinitionsGET(
        `/insights/views/quickDefinitions/${viewType}`,
        dateRange
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  fetchInsightsFilterDefinitions(viewType, dateRange = null) {
    const res = apiService
      .requestInsightsFilterDefinitionsGET(
        `/insights/views/filterDefinitions/${viewType}`,
        dateRange
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  fetchInsightsViewsConfigs(viewType) {
    const res = apiService
      .requestInsightsViewConfigGET(`/insights/views/${viewType}`)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    return res;
  }

  /**
   * Fetches dynamic filter definitions based on retailer and categories
   * Queries the brand_performance_definitions index for permission-filtered brands and keywords
   * @param {string} retailer - Retailer domain (e.g., "amazon.com")
   * @param {Array<string>} categories - Optional array of category paths (uses user permissions if not provided)
   * @param {Object} dateRange - Optional date range
   * @returns {Promise<{brands: string[], keywords: string[]}>}
   */
  fetchDynamicFilterDefinitions(retailer, categories = null, dateRange = null) {
    // Build query string params
    let queryString = `retailer=${encodeURIComponent(retailer)}`;
    
    if (categories && categories.length > 0) {
      // Add categories as array params
      const categoryParams = categories
        .map(cat => `categories=${encodeURIComponent(cat)}`)
        .join('&');
      queryString += `&${categoryParams}`;
    }
    
    const fullUrl = `/insights/views/dynamicFilterDefinitions?${queryString}`;
    
    const res = apiService
      .requestInsightsFilterDefinitionsGET(fullUrl, dateRange)
      .then((response) => {
        // Extract data from axios response
        const data = response.data;
        // Backend returns: { brands: [...], keywords: [...] }
        return Promise.resolve(data);
      })
      .catch((error) => {
        console.error('[Service] Error fetching dynamic filter definitions:', error);
        return Promise.reject(error);
      });
    return res;
  }
}
